<template>
    <div class="banner bng-sport-banner-new-live-games">
        <img
            :src="isMobilePhone ? '/static/banners/sport-home-banner/mobile/new_live_games.jpg' : '/static/banners/sport-home-banner/desktop/new_live_games.jpg'"
        />
        <div class="content">
            <div>
                <div>
                    <b>{{"components.common.banners.sport-banners.new-live-games.msg1" | translate}}</b>
                    <span>{{"components.common.banners.sport-banners.new-live-games.msg2" | translate}}</span>
                </div>
            </div>
        </div>
        <div class="detailed">
            <router-link :to="{ name: 'video-games' }">{{"components.common.banners.sport-banners.new-live-games.play" | translate}}</router-link>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import isMobile from 'ismobilejs';

export default {
    name: 'sport-banner-new-live-games',
    computed: {
        client() {
            return Vue.state.client.get();
        },
        isMobilePhone() {
            return isMobile.phone;
        },
        percent() {
            return this.client && this.client.bonus.cashback && this.client.bonus.cashback.percent;
        }
    }
};
</script>
<style lang="scss">
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/common/banners/sport-banners/new-live-games.vue